import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { COMMUNITY_MEMBERS_RESOURCE } from '../../constants';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_MEMBERS_RESOURCE,
      method: 'get',
      request: communityId => ({
        url: apiRoutes.getCommunityMembers(communityId),
      }),
    },
  ])(ComposedComponent);
